import * as React from 'react';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Platform } from 'react-native';

import { Box } from '@fhs-legacy/universal-components';

import BaseReceiptHeadInfo from './receipt-head-info.base';
import { Title } from './receipt-head-info.styled';
import { IOrderHeaderProps } from './types';

/** `nativeID` / `aria-labelledby` target for the Order Details heading and receipt main landmark. */
export const RECEIPT_ORDER_DETAILS_TITLE_NATIVE_ID = 'receipt-order-details-title';

const ReceiptHeadInfo: FC<React.PropsWithChildren<IOrderHeaderProps>> = ({ order }) => {
  const { formatMessage } = useIntl();
  return (
    <Box>
      <Title
        nativeID={RECEIPT_ORDER_DETAILS_TITLE_NATIVE_ID}
        accessibilityRole="header"
        accessibilityLevel={2}
        tabIndex={Platform.OS === 'web' ? (0 as const) : undefined}
      >
        {formatMessage({ id: 'orderDetailsHeading' })}
      </Title>
      <BaseReceiptHeadInfo order={order} />
    </Box>
  );
};

export default ReceiptHeadInfo;
